import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";
import { NotificacaoNcmEntity } from '@catalogo/models';

@Injectable({ providedIn: 'root' })
export class NotificacaoNcmDataService extends CrudService<NotificacaoNcmEntity> {

    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/Notificacao/Ncm`;
    }

    public obterResumoUltimaNotificacaoAtributosModificados = (ncmId: string) =>
        this.httpClient.get<ApiResult<NotificacaoNcmEntity>>(`${this.url}/${ncmId}`);

}
